<template>
  <div>
       <div class="weui-mask"></div>
       <div class="weui-dialog">
           <div class="weui-dialog__bd">{{msg}}</div>
           <div class="weui-dialog__ft">
               <a href="javascript:"
               @click="$emit('fashe')"
                class="weui-dialog__btn weui-dialog__btn_primary">确定</a>
           </div>
       </div>
   </div>
</template>

<script>
  export default{
    props:['msg'],
    methods:{
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/Dialog.vue